import $ from 'jquery';

const handleChartError = (message, chartType) => {
  $(document).ready(() => {
    const newMessage =
      chartType === 'BubbleChart'
        ? getBubbleChartMessage(message)
        : chartType === 'ScatterChart'
        ? getScatterChartMessage(message)
        : null;

    if (newMessage)
      $('div[id*=google-visualization-errors] span')
        .text(newMessage)
        .css('font-size', '12px');
  });
};

function getBubbleChartMessage(message = '') {
  // Replace messages like:
  // "Column 1 cannot be of type string" with "Field selected for x-axis cannot be a string"
  // "Column 4 must be of type number" with "Field selected for sizes must be a number"
  const separator = message.includes('cannot be of type')
    ? 'cannot be of type'
    : message.includes('must be of type')
    ? 'must be of type'
    : '';

  if (separator) {
    const [columnName, dataType] = message.split(` ${separator} `);
    const fieldName = getFieldNameForBubbleChart(columnName);
    const constraint = separator.replace('of type', 'a');

    if (fieldName && dataType) {
      return `Field selected for ${fieldName} ${constraint} ${dataType}`;
    }
  }
  return null;
}

function getScatterChartMessage(message) {
  if (message === 'Data column(s) for axis #0 cannot be of type string')
    return 'Field selected for y-axis cannot be a string';
  return null;
}

function getFieldNameForBubbleChart(columnName) {
  switch (columnName) {
    case 'Column 0':
      return 'labels';
    case 'Column 1':
      return 'x-axis';
    case 'Column 2':
      return 'y-axis';
    case 'Column 3':
      return 'series';
    case 'Column 4':
      return 'sizes';
    default:
      return null;
  }
}

export { handleChartError };
